import { useEffect } from "react";

// In-memory cache so returning from a media page restores the list + scroll
// position instantly instead of refetching and jumping to the top.
const CACHE = new Map();

export function readFeedCache(key) {
  return key ? CACHE.get(key) : null;
}

export function restoreScroll(y) {
  requestAnimationFrame(() => requestAnimationFrame(() => window.scrollTo(0, y || 0)));
}

// Persists `items`/`hasMore` (plus any `extra`) and the live scroll position for `key`.
export function useFeedCache(key, items, hasMore = true, extra = {}) {
  useEffect(() => {
    if (key && items && items.length) {
      CACHE.set(key, { ...(CACHE.get(key) || {}), items, hasMore, ...extra });
    }
  }, [key, items, hasMore]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (!key) return;
    const onScroll = () => CACHE.set(key, { ...(CACHE.get(key) || {}), scrollY: window.scrollY });
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, [key]);
}
